import React, { useEffect, useState } from "react";
import "./PartnerStatusUpdateCard.scss";

import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  MdSend,
  MdWarningAmber,
  MdLocationOn,
  MdLocalShipping,
  MdDateRange,
  MdMyLocation,
} from "react-icons/md";

import { getPartnerCurrentLocation } from "../../store/statusUpdates/partnerShipmentStatus/partnerShipmentStatusSlice";

import DSelect from "../../componentsDashboard/Form/DSelect/DSelect";
import DInputs from "../../componentsDashboard/Form/DInputs/DInputs";
import DDatepicker from "../../componentsDashboard/Form/DDatepicker/DDatepicker";
import DButton from "../../componentsDashboard/Form/DButtons/DButton/DButton";
import DTextButton from "../../componentsDashboard/Form/DButtons/DTextButton/DTextButton";
import PartnerStatusLastUpdate from "../PartnerStatusLastUpdate/PartnerStatusLastUpdate";
import ButtonLoader from "../../componentsDashboard/Form/DButtons/ButtonLoader/ButtonLoader";

const PartnerStatusUpdateCard = ({ order }) => {
  const dispatch = useDispatch();
  const { signature } = useParams();

  const {
    getPartnerCurrentLocationResult,
    getPartnerCurrentLocationLoading,
    getPartnerCurrentLocationError,
  } = useSelector((state) => state.partnerShipmentStatus);

  const [status, setStatus] = useState(null);
  const [location, setLocation] = useState("");
  const [estDelivery, setEstDelivery] = useState("");
  const [reason, setReason] = useState(null);

  const cargo = order?.cargos?.[0];

  const getCurrentLocation = () => {
    navigator.geolocation.getCurrentPosition((position) => {
      const { latitude, longitude } = position.coords;
      dispatch(
        getPartnerCurrentLocation({
          signature,
          lat: latitude,
          lng: longitude,
        })
      );
    });
  };

  useEffect(() => {
    setStatus(null);
    setLocation("");
    setEstDelivery("");
    setReason(null);
  }, [order]);

  useEffect(() => {
    if (getPartnerCurrentLocationResult) {
      setLocation(getPartnerCurrentLocationResult?.formatted_address);
    }
  }, [getPartnerCurrentLocationResult]);

  return (
    <div id='PartnerStatusUpdateCard'>
      <div className='titleContainer'>
        <div className='icon'>
          <MdWarningAmber />
        </div>
        <h2>Status update required</h2>
      </div>
      <div className='statusUpdateFormContainer'>
        <div className='statusUpdateForm'>
          <div className='routeAndTrailerNumbers'>
            <div className='itemContainer'>
              <div className='icon'>
                <MdLocationOn />
              </div>
              <div className='text'>
                {cargo?.locations?.[0]?.country || "GE"} →{" "}
                {cargo?.locations?.[cargo?.locations?.length - 1]?.country || "ES"}
              </div>
            </div>
            <div className='itemContainer'>
              <div className='icon'>
                <MdLocalShipping />
              </div>
              <div className='text'>{order?.transports?.[0]?.number}</div>
            </div>
          </div>
          <DSelect
            id='status'
            label='Status'
            placeholder={"Select status"}
            value={status}
            setValue={setStatus}
            options={[]}
          />
          <DInputs
            id={"currentLocation"}
            label={"Current location"}
            placeholder={"Type location"}
            value={location}
            setValue={setLocation}
            icon={
              !getPartnerCurrentLocationLoading ? (
                location && (
                  <MdMyLocation
                    color='#2e5aac'
                    onClick={() => {
                      getCurrentLocation();
                    }}
                  />
                )
              ) : (
                <ButtonLoader />
              )
            }
            error={getPartnerCurrentLocationError?.message}
            button={
              !location && (
                <DTextButton
                  leftIcon={<MdMyLocation />}
                  info
                  title={"Use current location"}
                  onClick={() => {
                    getCurrentLocation();
                  }}
                  loading={getPartnerCurrentLocationLoading}
                />
              )
            }
          />
          <DDatepicker
            id={"estDelivery"}
            label={"Estimated delivery"}
            placeholder={"Select date"}
            value={estDelivery}
            setValue={setEstDelivery}
          />
          {true && (
            <>
              <div className='warningInfo'>
                <div className='icon'>
                  <MdDateRange />
                </div>
                <div className='text'>
                  You have updated the estimated delivery date from <span>[old date]</span> to{" "}
                  <span>[new date]</span>. Please select the reason for this change to keep records
                  accurate
                </div>
              </div>
              <DSelect
                id='reason'
                label='Reason'
                placeholder={"Select reason"}
                value={reason}
                setValue={setReason}
                options={[]}
              />
            </>
          )}
        </div>
        <DButton title={<MdSend />} onClick={() => {}} loading={false} />
      </div>
      <PartnerStatusLastUpdate order={order} />
    </div>
  );
};

export default PartnerStatusUpdateCard;
